<template>
  <v-card>
    <v-card-title>
          <router-link :to="{ name: 'awx_add'}">
            <v-icon small  class="mr-2"> add </v-icon>
          </router-link>      <v-spacer></v-spacer>
      <div class="my-2">
        <v-btn small color="primary" @click="this.getlist" >update list</v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      dense
      :headers="getheaers"
      :items="list"
      :search="search"
      :options.sync="pagination"
      :rowsPerPageItems="rowsPerPageItems"
      class="elevation-1"
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <router-link :to="{ name: 'awx_edit', params: { id: props.item.aid }}">
              <v-icon small  class="mr-1"> edit </v-icon>
            </router-link>

          </td>
          <td v-for="value in props.item" :key="value" class="text-xs-right"> {{ value }} </td>
        </tr>
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>

  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        schema: [],
        list: [],
        headers: [],
        rowsPerPageItems: [10, 20, 40, 80 ,160, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
        pagination: {
            rowsPerPage: 40,
        },
      }
    },
      mounted() {
        this.getlist();
  },
    computed: {
    getheaers: function () {
        var obj1= [];
        obj1.push({ text: 'Actions', value: 'name', sortable: false })
        for ( var key in this.schema.properties) {
          if(this.schema.properties[key]['x-list']){
            obj1.push({ text: this.schema.properties[key].title, value: key, align: 'right', });
        }}
      return obj1
    },


  },
  methods: {
  	log: function(a) {
    	// console.log(a);
    },
    getlist: function(){
      if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
       this.$http
      .get(this.$root.apiUrl+'/api/v1/schemas/awx.json')
      .then(response => (this.schema = response.data))
  //    .then(this.getkeydata)
      .then(console.log(this.schema));
      this.$http.get(this.$root.apiUrl+'/api/v1/awx/get_all/').then(response => (this.list = response.data.result));
    },
    getkeydata: function(){
       for ( var key  in this.schema.properties) {
            if(this.schema.properties[key]['x-fromUrl']){
              this.getdirectory(key);
            }
        }
    },
    getdirectory: function(i){
      this.$http.get(this.schema.properties[i]['x-fromUrl'])
      .then(response => (this[i] = response.data.result))

    }

  },

  }

</script>

<style>

table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0px;
}
table.v-table tbody td, table.v-table tbody th {
    height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/awx/list.vue